/* eslint-disable max-len */
import React from 'react';

type PartyOutlineProps = {
  width?: number;
  height?: number;
  color?: string;
};

export function PartyOutline({ width = 48, height = 48, color = '#000000', ...props }: PartyOutlineProps): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 48 48' fill='none' {...props}>
      <title>Party Outline</title>
      <path
        d='M30.1475 31.9276C32.0909 29.984 30.5155 25.2577 26.6287 21.3707C22.7416 17.4838 18.0152 15.9083 16.0717 17.8517C14.1282 19.7952 15.7037 24.5218 19.5907 28.4086C23.4776 32.2956 28.2041 33.8711 30.1475 31.9276Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.2791 19.6396L2.93341 41.2919C2.68918 41.8203 2.61291 42.4106 2.71492 42.9837C2.81692 43.5566 3.09228 44.0846 3.50381 44.496C3.91536 44.9076 4.44325 45.1831 5.01625 45.2851C5.58925 45.3871 6.17974 45.3107 6.70802 45.0665L28.3604 32.7303'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.6249 2.67188C26.0251 6.25485 25.6825 9.88184 24.6182 13.3265'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.662 5.2843L31.6572 10.3102'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M45.3284 22.3752C41.7455 21.975 38.1184 22.3178 34.6738 23.3819'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42.7153 15.338L37.6895 16.3428'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.5752 11.0211C16.1826 11.0211 15.8643 10.7028 15.8643 10.3102C15.8643 9.91753 16.1826 9.59924 16.5752 9.59924'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M16.5752 11.0211C16.9678 11.0211 17.2861 10.7028 17.2861 10.3102C17.2861 9.91753 16.9678 9.59924 16.5752 9.59924'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M30.6504 17.0549C30.2576 17.0549 29.9395 16.7366 29.9395 16.344C29.9395 15.9513 30.2576 15.6331 30.6504 15.6331'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M30.6504 17.0549C31.043 17.0549 31.3613 16.7366 31.3613 16.344C31.3613 15.9513 31.043 15.6331 30.6504 15.6331'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M38.6943 9.01154C38.3015 9.01154 37.9834 8.69324 37.9834 8.3006C37.9834 7.90797 38.3015 7.58966 38.6943 7.58966'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M38.6943 9.01154C39.087 9.01154 39.4053 8.69324 39.4053 8.3006C39.4053 7.90797 39.087 7.58966 38.6943 7.58966'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M38.6943 29.1193C38.3015 29.1193 37.9834 28.801 37.9834 28.4084C37.9834 28.0158 38.3015 27.6974 38.6943 27.6974'
        stroke={color}
        strokeWidth='2'
      />
      <path
        d='M38.6943 29.1193C39.087 29.1193 39.4053 28.801 39.4053 28.4084C39.4053 28.0158 39.087 27.6974 38.6943 27.6974'
        stroke={color}
        strokeWidth='2'
      />
    </svg>
  );
}
